{
  "SEARCH": {
    "TABS": {
      "ALL": "Все",
      "CONTACTS": "Контакты",
      "CONVERSATIONS": "Диалоги",
      "MESSAGES": "Сообщения"
    },
    "SECTION": {
      "CONTACTS": "Контакты",
      "CONVERSATIONS": "Диалоги",
      "MESSAGES": "Сообщения"
    },
    "VIEW_MORE": "Посмотреть больше",
    "LOAD_MORE": "Загрузить ещё",
    "SEARCHING_DATA": "Идёт поиск",
    "LOADING_DATA": "Загрузка",
    "EMPTY_STATE": "Не найдено {item} для запроса '{query}'",
    "EMPTY_STATE_FULL": "Ничего не найдено по запросу '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ фокусироваться",
    "INPUT_PLACEHOLDER": "Введите 3 или более символов для поиска",
    "RECENT_MESSAGES": "Мои недавно отправленные сообщения",
    "EMPTY_STATE_DEFAULT": "Поиск по идентификатору разговора, электронной почте, номеру телефона, сообщениям для улучшения результатов поиска. ",
    "BOT_LABEL": "Бот",
    "READ_MORE": "Читать далее",
    "WROTE": "написал:",
    "FROM": "от",
    "EMAIL": "почта",
    "EMAIL_SUBJECT": "тема"
  }
}
